import {Snackbar,Alert} from '@mui/material'
import React from 'react'
import { createRoot } from 'react-dom/client';
function Message(props: { content: any; duration: any; type: any; }) {
    const { content, duration, type } = {...props};
    // 开关控制：默认true,调用时会直接打开
    const [open, setOpen] = React.useState(true);
    // 关闭消息提示
    const handleClose = (event: any, reason: any) => {
        setOpen(false);
    };
    return <Snackbar
        open={open}
        autoHideDuration={duration}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={handleClose}>
            <Alert severity={type}>{content}</Alert>
        </Snackbar>
}

const message = {
    success({content, duration=3000}:{content:string, duration?: any}): void {
        const dom = document.createElement('div');
        const root = createRoot(dom);
        // 定义组件， 
        const JSXdom = (<Message content={content} duration={duration} type='success'></Message>);
        // 渲染DOM
        root.render(JSXdom)
        // 置入到body节点下
        document.body.appendChild(dom);
    },
    error({content, duration=3000}:{content:string, duration?: any}): void {
        const dom = document.createElement('div');
        const root = createRoot(dom);
        const JSXdom = (<Message content={content} duration={duration} type='error'></Message>);
        root.render(JSXdom)
        document.body.appendChild(dom);
    },
    warning({content, duration=3000}:{content:string, duration?: any}): void {
        const dom = document.createElement('div');
        const root = createRoot(dom);
        const JSXdom = (<Message content={content} duration={duration} type='warning'></Message>);
        root.render(JSXdom)
        document.body.appendChild(dom);
    },
    info({content, duration=3000}:{content:string, duration?: any}): void {
        const dom = document.createElement('div');
        const root = createRoot(dom);
        const JSXdom = (<Message content={content} duration={duration} type='info'></Message>);
        root.render(JSXdom)
        document.body.appendChild(dom);
    }
};
 
export default message;